import { useEffect } from "react";
export const toLowercase = (str) => (str ? str.toLocaleLowerCase() : '');
const forceToArr = (str) => {
  if(!str || str.length === 0) return [];
  return toLowercase(str).split(',').map((x) => (x.trim())).filter((x) => (!!x))
}
export const toPermalink = (str) => {
  return !str
    ? str
    : toLowercase(str)
        .split(/\ |\-|\_|\(|\)|\'|\"|\.|\,|\&|\*|\:/) //no-useless-escape
        .join("_");
};

const deg2rad = (deg) => deg * (Math.PI / 180);

const kmToMile = (disKm) => {
  return disKm * 0.621371;
};

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  let R = 6371; // Radius of the earth in km
  let dLat = deg2rad(lat2 - lat1); // deg2rad below
  let dLon = deg2rad(lon2 - lon1);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c; // Distance in km

  return Math.ceil(d * 100) / 100;
};

export const getDistanceFromLatLonInMi = (lat1, lon1, lat2, lon2) => {
  const distance = getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2);
  return Math.ceil(kmToMile(distance) * 100) / 100;
};

export const sortNearbyLocations = (locations, userLat, userLng, inMiles = false) => {
  const sortedLocations = locations
    .map((loc) => {
      const distance = inMiles
        ? getDistanceFromLatLonInMi(userLat, userLng, loc.properties.lat, loc.properties.lng)
        : getDistanceFromLatLonInKm(userLat, userLng, loc.properties.lat, loc.properties.lng)
      return {
        ...loc,
        distance,
      };
    })
    .sort((a, b) => a.distance - b.distance);
  return sortedLocations;
};

export const ICONS = {
  CLEAR: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
  LOADER: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>`,
  COMPASS: ` <svg
   xmlns="http://www.w3.org/2000/svg"
   width="18"
   height="18"
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
 >
   <circle cx="12" cy="12" r="10"></circle>
   <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
 </svg>`,
  GLOBE: `
 <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="2" y1="12" x2="22" y2="12"></line>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
        </svg>
 `,
  SMARTPHONE: `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      >
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
      <line x1="12" y1="18" x2="12.01" y2="18"></line>
      </svg>`,
  EMAIL: `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>`,
  FB: `
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
    `,
  TW: `
    <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
        </svg>
    `,
  YTB: `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
    `,
  INS: `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-instagram"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
    `,
  CHECKED: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>`,
  FILTER: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="18px" width="18px" viewBox="0 0 24 24" class="sc-16r8icm-0 gbnzoE"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.99805 6.00342C1.99805 5.45113 2.44576 5.00342 2.99805 5.00342H21.0013C21.5536 5.00342 22.0013 5.45113 22.0013 6.00342C22.0013 6.5557 21.5536 7.00342 21.0013 7.00342H2.99805C2.44576 7.00342 1.99805 6.5557 1.99805 6.00342ZM4.99805 12C4.99805 11.4477 5.44576 11 5.99805 11H18.0013C18.5536 11 19.0013 11.4477 19.0013 12C19.0013 12.5523 18.5536 13 18.0013 13H5.99805C5.44576 13 4.99805 12.5523 4.99805 12ZM8.99805 16.9966C8.44576 16.9966 7.99805 17.4443 7.99805 17.9966C7.99805 18.5489 8.44576 18.9966 8.99805 18.9966H15.0013C15.5536 18.9966 16.0013 18.5489 16.0013 17.9966C16.0013 17.4443 15.5536 16.9966 15.0013 16.9966H8.99805Z"></path></svg>`,
  CARET: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>`,
  GEO: `<svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 512 640" enable-background="new 0 0 512 512" xml:space="preserve"><g><g><path d="M256,422c-91.533,0-166-74.467-166-166S164.467,90,256,90s166,74.467,166,166S347.533,422,256,422z M256,102    c-84.916,0-154,69.084-154,154s69.084,154,154,154s154-69.084,154-154S340.916,102,256,102z"></path></g><g><rect x="250" y="64" width="12" height="96"></rect></g><g><rect x="352" y="250" width="96" height="12"></rect></g><g><rect x="250" y="352" width="12" height="96"></rect></g><g><rect x="64" y="250" width="96" height="12"></rect></g></g></svg>`,
  SEARCH: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>`,
};

export const DEFAULT_RADIUSES = [1, 5, 10, 15, 20, 50, 100].map((x)=>({label: x, value: x}));


// Hook
export const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

export const cleanMapProperties = (props) => {
  const cleanedProps = {...props};
  cleanedProps.geolocation = !(cleanedProps.geolocation === 'false');
  cleanedProps.hiddenFilters = forceToArr(cleanedProps.hiddenFilters);
  cleanedProps.enabledTags = forceToArr(cleanedProps.enabledTags);
  cleanedProps.selectedTags = forceToArr(cleanedProps.selectedTags);
  cleanedProps.enabledTypes = forceToArr(cleanedProps.enabledTypes);
  cleanedProps.enabledRegions = forceToArr(cleanedProps.enabledRegions);
  cleanedProps.selectedType = cleanedProps.selectedType && cleanedProps.selectedType.length > 0 ? toLowercase(cleanedProps.selectedType).trim() : null;
  [
    "hiddenFilters",
    "enabledTags",
    "selectedTags",
    "enabledTypes",
    "selectedType",
    "mapCenterLat",
    "mapCenterLng",
    "enabledRegions",
  ].map((ky) => {
    if(!cleanedProps[ky] || cleanedProps[ky].length === 0) {
      delete cleanedProps[ky]
    }
  })
  return cleanedProps;
}

export const cleanAvailableTags = (accountTags, enabledTags) => {

  const availableTags = (accountTags || []).filter((tag) => (!enabledTags || enabledTags.length === 0 || enabledTags.indexOf(toLowercase(tag.name)) >= 0)).filter((tag) => (tag.visibility !== 'hidden'))
  return availableTags.map((tag) => ({
    label: tag.name, 
    value: tag.name,
    icon_url: tag.icon_url,
    color: tag.color
  }))
}

export const cleanAvailableTypes = (accountTypes, enabledTypes) => {
  const availableTypes = (accountTypes || []).filter((tag) => (
    !enabledTypes || enabledTypes.length === 0 || enabledTypes.indexOf(toLowercase(tag.name)) >= 0)
  ).filter((tag) => (tag.visibility !== 'hidden'))
  
  return availableTypes.map((tag) => ({
    label: tag.name, 
    value: tag.id,
    icon_url: tag.icon_url,
    color: tag.color
  }))
}

export const getAccountLocale = (key, account) => {
  window.allLocales = window.allLocales ? window.allLocales : {}
  
  if (!key) return "";
  window.allLocales[key] = 1;

  const readableKey = key.replace(/-|_/g, " ");
  if (!account) return readableKey;
  const { locales } = account;
  if (!locales) return readableKey;

  const defaultLocales = locales.find((lc) => lc.active && lc.is_default) || locales.find((lc) => lc.active);
  
  let browserLocales = locales.find(
    (lc) => lc.langcode === navigator.language
  );
  if (!browserLocales) {
    browserLocales = navigator.languages.length > 1
      ? locales.find((lc) => lc.langcode === navigator.languages[1])
      : null;
  }
  if (!browserLocales) {
    browserLocales = navigator.languages.length > 2
        ? locales.find((lc) => lc.langcode === navigator.languages[2])
        : null;
  }
  
  if (!browserLocales) {
    browserLocales = defaultLocales;
  }

  if (!browserLocales || !browserLocales.locales[key]) return readableKey;

  return browserLocales.locales[key] || readableKey;
}


export const cleanSelectedTags = (tags, selectedTags) => {
  if(!tags) return [];
  return tags
    .filter(
      (tag) => selectedTags && selectedTags.indexOf(toLowercase(tag.name)) >= 0
    )
    .map((tag) => tag.name);
};

export const cleanSelectedTypeId = (location_types, selectedType) => {
  if(!location_types) return '';
  const checkedType = location_types.find((lt) => toLowercase(lt.name) === selectedType);
  return checkedType ? checkedType.id : "";
};

export const processLocations = (data) => {
  const locations = data && data.length > 0 ? data.slice(0, 2000) : [];
  const points = locations.map((loc) => ({
    type: "Feature",
    properties: {
      cluster: false,
      ...loc,
    },
    geometry: {
      type: "Point",
      coordinates: [+loc.lng, +loc.lat],
    },
  }));
  return points;
};


